import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "element-header" }
const _hoisted_3 = { class: "element-box" }
const _hoisted_4 = { class: "form-header mb-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "form-buttons-w text-center" }

import companyService from '@/api/AddressBook/company';
import BaseInput from '@/components/base/BaseInput.vue';
import CreateButton from '@/components/CreateButton.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import useVuelidate from '@vuelidate/core';
import {email, helpers} from '@vuelidate/validators';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import {IAddressBook} from "@/interfaces/AddressBook/IAddressBook";
import BackButton from "@/components/button/BackButton.vue";
import SaveButton from "@/components/button/SaveButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const {t} = useI18n();
const route = useRoute();
const companyId = route.params.id;
const isSubmitting = ref(false);

const formData = ref <IAddressBook>({
  firstName: '',
  lastName: '',
  company: '',
  phoneNumber: '',
  email: '',
  address: '',
  zip: '',
  city: '',
  position: '',
  info: '',
});

// VALIDATION
const customMessages = {
  email: {
    invalid: t('form_validation.invalid_email'),
  },
};

const rules = computed(() => {
  return {
    email: {
      valid: helpers.withMessage(customMessages.email.invalid, email),
    },
  };
});

const v$ = useVuelidate(rules, formData);

async function getCompany() {
  try {
    const {data} = await companyService.getCompany(+companyId);
    formData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

const submitForm = async () => {
  v$.value.$touch(); // Trigger validation
  if (v$.value.$invalid) {
    return; // Prevent submission if the form is invalid
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {

    companyId ?
        await companyService.putCompany(formData.value, +companyId) :
        await companyService.postCompany(formData.value);

    await router.push({name: 'addressBookCompanyList'});
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
};

onMounted(async () => {
  CloseToast()
  if (companyId) {
    await getCompany();
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      _createVNode(BackButton, {
        label: _ctx.$t('general.button.back'),
        to: { name: 'addressBookCompanyList' },
        marginBottom: "5"
      }, null, 8, ["label"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h6", _hoisted_2, _toDisplayString(_unref(t)('general.contacts')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(t)('address_book.company')), 1),
        _createElementVNode("form", {
          onSubmit: _withModifiers(submitForm, ["prevent"]),
          novalidate: ""
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(BaseInput, {
                modelValue: formData.value.firstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.firstName) = $event)),
                label: _unref(t)('general.first_name'),
                type: "text"
              }, null, 8, ["modelValue", "label"]),
              _createVNode(BaseInput, {
                modelValue: formData.value.lastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.lastName) = $event)),
                label: _unref(t)('general.last_name'),
                type: "text"
              }, null, 8, ["modelValue", "label"]),
              _createVNode(BaseInput, {
                modelValue: formData.value.company,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.company) = $event)),
                label: _unref(t)('general.company_client'),
                type: "text"
              }, null, 8, ["modelValue", "label"]),
              _createVNode(BaseInput, {
                modelValue: formData.value.phoneNumber,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.phoneNumber) = $event)),
                label: _unref(t)('general.phone_number'),
                type: "text"
              }, null, 8, ["modelValue", "label"]),
              _createVNode(BaseInput, {
                modelValue: formData.value.email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.email) = $event)),
                validation: _unref(v$).email,
                messages: customMessages.email.invalid,
                label: _unref(t)('general.email'),
                type: "email"
              }, null, 8, ["modelValue", "validation", "messages", "label"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(BaseInput, {
                modelValue: formData.value.address,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.address) = $event)),
                label: _unref(t)('general.street'),
                type: "text"
              }, null, 8, ["modelValue", "label"]),
              _createVNode(BaseInput, {
                modelValue: formData.value.zip,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.zip) = $event)),
                label: _unref(t)('general.postal_code'),
                type: "text"
              }, null, 8, ["modelValue", "label"]),
              _createVNode(BaseInput, {
                modelValue: formData.value.city,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.city) = $event)),
                label: _unref(t)('general.city'),
                type: "text"
              }, null, 8, ["modelValue", "label"]),
              _createVNode(BaseInput, {
                modelValue: formData.value.position,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.position) = $event)),
                label: _unref(t)('general.position'),
                type: "text"
              }, null, 8, ["modelValue", "label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createVNode(TextEditor, {
                  modelValue: formData.value.info,
                  "onUpdate:modelValue": [
                    _cache[9] || (_cache[9] = ($event: any) => ((formData.value.info) = $event)),
                    _cache[10] || (_cache[10] = ($event: any) => (formData.value.info = $event))
                  ],
                  inputStyle: { height: '200px'},
                  label: _unref(t)('general.info')
                }, null, 8, ["modelValue", "label"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(SaveButton, {
              label: _unref(t)('general.button.save'),
              loading: isSubmitting.value
            }, null, 8, ["label", "loading"])
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}
}

})